import { Modal, Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import React from "react";
import { buildTranslationTextVm } from "../../../utils/translationVersions/buildTranslationTextVm";
import TranslationMissingDot from "../../../components/LanguageVersionSelect/TranslationMissingDot";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";
import { CompanyAccess } from "@me-team/host/main/graphql/types";

interface ConfirmDeleteModalProps {
    show: boolean;
    handleClose: () => void;
    onConfirm: () => void;
    groupName: string;
    groupNameOrigin?: string | null;
    isTranslationMode: boolean;
    canDeleteRestoreOptionsAndSupplements?: boolean;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
    show,
    handleClose,
    onConfirm,
    groupName,
    groupNameOrigin,
    isTranslationMode,
    canDeleteRestoreOptionsAndSupplements,
}) => {
    const { t } = useTranslation();
    const canDeleteRestoreOptionsAndSupplementsByRole = useRoleAccess(
        CompanyAccess.MenuOptionsAndSupplementsDeleteRestore
    );
    const canSubmitDeleteRestore = canDeleteRestoreOptionsAndSupplements ?? canDeleteRestoreOptionsAndSupplementsByRole;
    const groupNameVm = buildTranslationTextVm({
        translatedValue: groupName,
        originValue: groupNameOrigin,
        isTranslationMode,
    });

    return (
        <Modal centered show={show} onHide={handleClose}>
            <Modal.Header closeButton className="border-0">
                <Modal.Title className="fs-5">
                    {t('DeleteOption "{{groupName}}"', {
                        groupName: groupNameVm.displayText,
                    })}
                    {groupNameVm.isMissingTranslation ? (
                        <TranslationMissingDot tooltipText={t("Edit the language version")} />
                    ) : null}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mx-auto col-sm-10">
                    <p className="text-center mb-0">
                        {t("Are you sure you want to remove the option from this menu?")}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-0">
                <Col>
                    <Button variant="outline-primary" className="w-100 h-100" onClick={handleClose}>
                        {t("cancel")}
                    </Button>
                </Col>
                <Col>
                    <Button
                        variant="primary"
                        className="w-100 fw-bold"
                        disabled={!canSubmitDeleteRestore}
                        onClick={() => {
                            if (!canSubmitDeleteRestore) return;
                            onConfirm();
                        }}
                    >
                        {t("delete")}
                    </Button>
                </Col>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmDeleteModal;
